type RuntimeEnv = {
  REACT_APP_SECURITY_API?: string;
  REACT_APP_SECURITY_VERSION?: string;
  REACT_APP_MULTI_TENANT_API?: string;
  REACT_APP_MULTI_TENANT_VERSION?: string;
};

declare global {
  interface Window {
    __ENV__?: RuntimeEnv;
  }
}

const getRuntimeEnv = (key: keyof RuntimeEnv): string | undefined => {
  if (typeof window === "undefined" || !window.__ENV__) return undefined;
  const value = window.__ENV__[key];
  return value && value.length > 0 ? value : undefined;
};

export const getConfigValue = (key: keyof RuntimeEnv, fallback?: string): string | undefined =>
  getRuntimeEnv(key) ?? fallback;
